import { Gus } from "./gus.model";

export class Guses {
  constructor(guses) {
    const data = [];
    for (const gus of guses) {
      data.push(new Gus(gus));
    }
    return data;
  }
}
